import {AppBar} from '@material-ui/core';
import React, {useEffect, useState} from 'react';
import {ReducerState} from 'rootReducer';
import {useDispatch, useSelector} from 'react-redux';
import './QuotingPage.sass';
import {NoOp} from 'Shared/utilities/IOUtilities';
import Column from 'Shared/components/PagedView/Column';
import PagedView from 'Shared/components/PagedView/PagedView';
import {QuotingRouteConstants} from 'Quoting/Routes';
import {Link} from 'react-router-dom';
import {Button, Typography} from '@material-ui/core';
import {changeQuoteSearchType, changeQuoteSearchValue, clearSearchQuote, fetchQuotes} from 'Quoting/ducks/quoteSearch';
import {toFormattedDate} from 'Shared/utilities/DateFormatter';
import {QuoteSearchDto} from 'Quoting/models/DTOs/QuoteSearch';

export enum QuoteSearchType {
  Opportunity = 1,
  CustomerName = 2,
  CustomerNumber = 3,
}
const createCSVFromProducts = (quote: QuoteSearchDto) => {
  // Extract product codes
  let results = '';
  if (quote.products) {
    const productCodes = quote.products.map((product: any) => (product.productCd ? product.productCd : ''));
    const csvContent = productCodes.join(', ');
    results = csvContent;
  }
  return results;
};
const QuotingPage = () => {
  const {searchtype, searchvalue, quotes} = useSelector((state: ReducerState) => state.quoteSearch);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchQuotes(searchtype, searchvalue));
  }, [dispatch, fetchQuotes]);

  const searchQuotingFilter = () => {
       dispatch(fetchQuotes(searchtype, searchvalue));
  };
  const handleEnter = (event) => {
    if (event.key === 'Enter') {
      searchQuotingFilter();
    }
  };

  const Header = (
    <div className="">
      <AppBar className={`quoting-search-bar__bar`} position="static">
        <div className={`quoting-search-bar__content`}>
          <div className="quoting-search-bar__searchLabel">Search By:</div>
          <div className="quoting-search-bar__input-container">
            <select
              aria-label="Select search criteria"
              id="search-type-select"
              onChange={e => dispatch(changeQuoteSearchType(parseInt(e.target.value, 10)))}
              value={searchtype}
              className="quoting-search-bar__search-type"
            >
              <option key={`search-item-${QuoteSearchType.Opportunity}`} value={QuoteSearchType.Opportunity}>
                Opportunity Number
              </option>
              <option key={`search-item-${QuoteSearchType.CustomerName}`} value={QuoteSearchType.CustomerName}>
                Customer Name
              </option>
              <option key={`search-item-${QuoteSearchType.CustomerNumber}`} value={QuoteSearchType.CustomerNumber  }>
                Customer Number
              </option>
            </select>
            <input
              id="search-bar-input"
              onChange={e => dispatch(changeQuoteSearchValue(e.target.value))}
              className={'quoting-search-bar__input'}
              placeholder="Search"
              onKeyDown={e => handleEnter(e)}
              value={searchvalue || ''}
            />
            <Button
              onClick={() => searchQuotingFilter()}
              className={'quoting-search-bar__search-button'}
              variant="contained"
              style={{marginLeft: '0.5rem'}}
            >
              Search <i className="fa fa-search quoting-search-bar__search-icon" />
            </Button>
          </div>
        </div>
      </AppBar>
    </div>
  );
  return (
    <>
      <h1>Opportunity Cases</h1>
      {Header}
      <PagedView pagedViewKey="quotes" data={quotes} loadMore={NoOp}>
        {columnProps => (
          <>
            <Column {...columnProps} title="Opportunity #" default>
              {claim => (
                <Link to={QuotingRouteConstants.OPPORTUNITY_SUMMARY(claim.opportunityNumber!)}>
                  <Button color="primary">
                    <Typography variant="body2">{claim.opportunityNumber}</Typography>
                  </Button>
                </Link>
              )}
            </Column>
            <Column {...columnProps} title="Account Name" default>
              {claim => claim.accountName}
            </Column>
            <Column {...columnProps} title="Effective Date" default>
              {claim => toFormattedDate(claim.effectiveDate!)}
            </Column>
            <Column {...columnProps} title="Products" default>
              {claim => createCSVFromProducts(claim)}
            </Column>
            <Column {...columnProps} title="Status" default>
              {claim => claim.status}
            </Column>
          </>
        )}
      </PagedView>
    </>
  );
};

export default QuotingPage;

